import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { IUser } from "../../../types/user";
import { useProfileImage } from "../../../context/ProfileImageContext";

interface MyProfileProps {
  profile: IUser;
}

const MyProfile = ({ profile }: MyProfileProps) => {

  const { coverImage, avatarImage } = useProfileImage();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  return (
    <>
      <div className="user-profile-img">

        {coverImage && (
          <img
            src={coverImage}
            className="profile-img"
            // style={{ height: "160px", width: "100%", objectFit: "cover" }}
            style={{ height: "160px" }}
            alt="cover"
          />
        )}

        <div className="overlay-content">
          <div className="user-chat-nav p-2 ps-3">
            <div className="d-flex w-100 align-items-center">

              <div className="flex-grow-1">
                <h5 className="text-white mb-0">Meu Perfil</h5>
                <small className="text-xs text-white mb-0">v1.8.0</small>
              </div>

              {/* <div className="flex-shrink-0">
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                  <DropdownToggle color="none" className="btn nav-btn text-white">
                    <i className="bx bx-dots-vertical-rounded"></i>
                  </DropdownToggle>

                  <DropdownMenu className="dropdown-menu-start">
                    <DropdownItem href="#">
                      Informação
                      <i className="bx bx-info-circle ms-2 text-muted"></i>
                    </DropdownItem>

                    <DropdownItem href="#">
                      Configuração
                      <i className="bx bx-cog ms-2 text-muted"></i>
                    </DropdownItem>

                    <DropdownItem divider />

                    <DropdownItem href="#">
                      Ajuda
                      <i className="bx bx-help-circle ms-2 text-muted"></i>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div> */}

            </div>
          </div>
        </div>
      </div>

      <div className="text-center p-3 p-lg-4 border-bottom pt-2 mt-n5 position-relative">

        {avatarImage && coverImage && (
          <img
            src={avatarImage}
            className="rounded-circle avatar-lg img-thumbnail"
            alt="Avatar"
          />
        )}


        <h5 className="font-size-16 mb-1 text-white text-truncate">
          {profile.name}
        </h5>

        <p className="text-muted font-size-14 text-truncate mb-0">{profile.role}</p>
      </div>
    </>
  );
};

export default MyProfile;
